import { Flex, Heading, Button, FormControl, FormLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Box, RadioGroup, Radio } from '@chakra-ui/react'; 
import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import CustomInput from '../../../../components/common/Input/input';
import * as api from '../../../../api/aplicativo';
import Swal from 'sweetalert2';

function EditarAplicativo() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formValues, setFormValues] = useState({
    dscAplicativo: { value: '', error: false },
    dscToken: { value: '', error: false },
    numRegistro: { value: 0, error: false }
  });

  const fetchAplicativo = async () => {
    if (!id) return;

    try {
      const data = await api.obterAplicativo(Number(id));
      setFormValues({
        dscAplicativo: { value: data.dscAplicativo, error: false },
        dscToken: { value: data.dscToken, error: false },
        numRegistro: { value: data.numRegistro, error: false }
      });
    } catch (error) {
      console.error('Erro ao obter aplicativo:', error);
    }
  };

  useEffect(() => {
    fetchAplicativo();
  }, [id]);

  const isFormValid = () => {
    const { dscAplicativo } = formValues;
    return dscAplicativo.value.trim().length >= 5;
  };

  const handleFieldChange = (field: string, value: any) => {
    setFormValues({
      ...formValues,
      [field]: { error: false, value }
    });
  };

  const handleSubmit = async () => {
    const { dscAplicativo, dscToken, numRegistro } = formValues;

    const params = {
      dscAplicativo: dscAplicativo.value.trim() !== '' ? dscAplicativo.value : null,
      dscToken: dscToken.value || null,
      numRegistro: numRegistro.value
    };

    try {
      await api.editarAplicativo(Number(id), params);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Aplicativo editado com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/configuracao/aplicativo');
      });
    } catch (error) {
      console.error('Erro ao editar aplicativo:', error);
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: 'Erro ao editar aplicativo. Tente novamente mais tarde.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/configuracao/aplicativo');
      });
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading mt="30px" mb="20px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Aplicativo
      </Heading>
      <div className="row mb-3">
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Descrição do Aplicativo</FormLabel>
            <CustomInput
              placeholder='Digite uma descrição'
              value={formValues.dscAplicativo.value}
              onChange={(e) => handleFieldChange('dscAplicativo', e.target.value)}
              maxLength={60}
            />
          </FormControl>
        </div>
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Token</FormLabel>
            <CustomInput
              placeholder='Digite um token'
              value={formValues.dscToken.value}
              onChange={(e) => handleFieldChange('dscToken', e.target.value)}
              maxLength={60}
            />
          </FormControl>
        </div>
        <div className="col-md-6 mb-4">
          <FormControl isRequired>
            <FormLabel mb="8px">Situação</FormLabel>
            <RadioGroup mt={3.5} onChange={(value) => handleFieldChange('numRegistro', Number(value))} value={formValues.numRegistro.value.toString()}>
              <Radio value="1" mr={5}>Ativo</Radio>
              <Radio value="0">Inativo</Radio>
            </RadioGroup>
          </FormControl>
        </div>
      </div>

      <Box alignItems={'flex-end'}>
        <Button m="px" onClick={() => navigate(-1)}>
          Desistir
        </Button>
        <Button
          m="6px"
          color="#FFF"
          bgColor="#1665D8"
          _hover={{ opacity: 0.8 }}
          onClick={handleSubmit}
          isDisabled={!isFormValid()}
        >
          Editar Aplicativo
        </Button>
      </Box>
    </Flex>
  );
}

export default EditarAplicativo;
